import React, {Component} from "react"

import {H3, Body} from "@irati/ui/src/Typography"
import ghost from "@irati/ui/images/circle_ghost.svg"
import {FormattedMessage} from "@irati/utils/lang"
import PopUpWithImage from "@irati/ui/src/PopUpWithImage"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import Flex from "@irati/ui/src/Flex"
import {RouterLink} from "@irati/ui/src/Link"

class StockNotificationPopup extends Component {
  popup = React.createRef<PopUpWithImage>()

  componentDidMount() {
    if (this.popup.current) {
      this.popup.current.open()
    }
  }

  render() {
    return (
      <PopUpWithImage ref={this.popup} img={ghost}>
        <H3 base>
          <FormattedMessage id="perks.components.productForms.stockNotificationPopup.text.first" />
          <br />
          <FormattedMessage id="perks.components.productForms.stockNotificationPopup.text.second" />
        </H3>
        <Body>
          <FormattedMessage id="perks.components.productForms.noStock.description" />
          <RouterLink to="/">
            <FormattedMessage id="perks.components.productForms.noStock.desc.link" />
          </RouterLink>
        </Body>
        <Flex justifyContent="center" marginTop={4}>
          <RouterLink to="/">
            <Flex alignItems="center">
              <FormattedMessage id="perks.components.productForms.noStock.discover" />
              <Icon icon={IconTypes.arrowRight} marginLeft />
            </Flex>
          </RouterLink>
        </Flex>
      </PopUpWithImage>
    )
  }
}

export default StockNotificationPopup
